export default "__VITE_ASSET__Cchn$eyr__"